/**
 * @file index.ts
 * @description i18next initialization. Loads he/en bundles, auto-detects the
 *   browser locale, and falls back to Hebrew (project primary language).
 * @module i18n
 * @security No user input flows through translation keys. Interpolation values
 *   in components must be sanitized at their source (e.g. in services that
 *   produce names) before being passed in.
 */

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import he from './he.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      he: { translation: he },
      en: { translation: en },
    },
    fallbackLng: 'he',
    supportedLngs: ['he', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['htmlTag', 'navigator', 'localStorage'],
      caches: ['localStorage'],
    },
  });

export default i18n;
